import namespace from '@/store/namespace'
export default namespace('utils',{
    getters:[
        'Getdialogo',
        'GetdialogProgress',
        'GetdialogProgressLabel',
        'GetOficinas',
        'GetRequisitoTramite'
    ],
    actions:[
        'ObtenerFechaServidor',
        'ObtenerOficinas',
        'VerificarHoras'
    ],
    mutations:[
        'SetdialogProgress',
        'SetOpenProgressWithMessage',
        'SettipoAmpMod',
        'SetOficinas',
        'SetRequisitoTramite'
    ]
})
